import React from 'react';

export default function MascotBubble({ children, tone = 'purple', position = 'left' }) {
    const palettes = {
        purple: 'bg-lq-purple-100 text-lq-purple-900 border-lq-purple-300',
        peach: 'bg-lq-peach-100 text-lq-ink-900 border-lq-peach-300',
        sky: 'bg-lq-sky-100 text-lq-ink-900 border-lq-sky-300',
    };
    const radius = position === 'left'
        ? 'rounded-3xl rounded-bl-sm'
        : 'rounded-3xl rounded-br-sm';
    return (
        <div className={`inline-block max-w-md px-5 py-3 border ${palettes[tone]} ${radius} font-display text-lg leading-snug shadow-sm`}>
            {children}
        </div>
    );
}

export function MascotAvatar({ variant = 'sekuru' }) {
    // Lightweight SVG avatar, Gogo (grandma) or Sekuru (grandpa). Placeholder
    // until the real illustrations are extracted from the book covers.
    const isGogo = variant === 'gogo';
    return (
        <svg viewBox="0 0 100 120" width="80" height="96" aria-hidden="true">
            <defs>
                <radialGradient id="face-grad" cx="50%" cy="40%" r="60%">
                    <stop offset="0%" stopColor="#D9A079" />
                    <stop offset="100%" stopColor="#9A6B4A" />
                </radialGradient>
            </defs>
            {/* Head */}
            <ellipse cx="50" cy="50" rx="32" ry="36" fill="url(#face-grad)" />
            {/* Hair / head wrap */}
            {isGogo ? (
                <path d="M18 50 Q20 14 50 14 Q80 14 82 48 Q76 40 62 38 Q50 36 40 40 Q26 44 18 50 Z" fill="#3B2A4E" />
            ) : (
                <path d="M18 48 Q22 20 50 20 Q78 20 82 48 Q72 40 50 40 Q28 40 18 48 Z" fill="#2A2330" />
            )}
            {/* Glasses */}
            <circle cx="38" cy="54" r="6" fill="none" stroke="#14111C" strokeWidth="2" />
            <circle cx="62" cy="54" r="6" fill="none" stroke="#14111C" strokeWidth="2" />
            <line x1="44" y1="54" x2="56" y2="54" stroke="#14111C" strokeWidth="2" />
            {/* Smile */}
            <path d="M40 70 Q50 78 60 70" stroke="#14111C" strokeWidth="2" fill="none" strokeLinecap="round" />
            {/* Body */}
            <rect x="30" y="85" width="40" height="35" rx="6" fill={isGogo ? '#A33E4F' : '#5B2885'} />
            <rect x="32" y="95" width="36" height="4" fill={isGogo ? '#7A2A39' : '#3A1A55'} opacity="0.6" />
        </svg>
    );
}
